import React from 'react';
import _ from 'lodash';

import {
  Box,
  Card,
  CardContent,
  Stack
} from '@mui/material';
import {
  activityTemplates,
  ApiRequestTable,
  SpinningInProgressIndicator
} from 'modules';
import {
  Check,
  Close
} from '@mui/icons-material';

import { Table } from 'iron-forge-react-modules';
import * as dataService from './dataService';
import * as types from './types';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export const AppleCareAgreementsActivity: React.FC = () => {
  const {
    queryTuple,
    pageInfo,
    fnQueryPage
  } = dataService.useQuery();



  const rows = React.useMemo(
    () => _.map(queryTuple.data.agreements, (data): types.IRow => ({
      id: data.id,
      columnId2Value: {
        activatedAt: {
          type: 'string',
          label: data.activatedAt?.toFormat('yyyy-MM-dd hh:mm a') ?? '-'
        },
        agreementNumber: {
          type: 'string',
          label: data.agreementNumber
        },
        orderDate: {
          type: 'string',
          label: data.orderDate.toFormat('yyyy-MM-dd hh:mm a')
        },
        orderNumber: {
          type: 'string',
          toRoute: data.routeToOrderDetail,
          label: data.orderNumber
        },
        productName: {
          type: 'string',
          label: data.productName
        },
        serialNumber: {
          type: 'string',
          label: data.serialNumber
        },
        sku: {
          type: 'string',
          label: data.sku
        },
        activationStatus: {
          type: 'component',
          sortableValue:'',
          label: (
            <Box>
              {data.activationStatus === 'activated' && (
                <Check color="success" />
              )}

              {data.activationStatus === 'error' && (
                <Close color="error" />
              )}

              {data.activationStatus === 'pending' && (
                <SpinningInProgressIndicator.FC />
              )}
            </Box>
          )
        }
      },
      expandedContent: !_.isEmpty(data.apiRequests) ? (
        <Stack direction="row" spacing={3}>
          <Box>
            {/* TODO: [QIPC-25284] Add buttons to perform remedial actions for AppleCare activations, etc. */}
          </Box>

          <ApiRequestTable.FC apiRequests={data.apiRequests} />
        </Stack>
      ) : undefined
    })),
    [queryTuple]
  );

  return (
    <activityTemplates.AdminActivityTemplate.FC>
      <Stack spacing={3}>
        <Card>
          <CardContent>
            <TableComponent
              disableSorting
              rows={rows}
              paginationOptions={Table.pageInfo2PaginationOptions(pageInfo, fnQueryPage)}
              initSortOptions={{
                columnId: 'orderDate',
                direction: 'descending'
              }}
              columns={[
                {
                  id: 'orderNumber',
                  label: "Order Number"
                },
                {
                  id: 'orderDate',
                  label: "Order Date"
                },
                {
                  id: 'productName',
                  label: "Product Name"
                },
                {
                  id: 'sku',
                  label: "SKU"
                },
                {
                  id: 'agreementNumber',
                  label: "Agreement Number"
                },
                {
                  id: 'serialNumber',
                  label: "Serial Number"
                },
                {
                  id: 'activatedAt',
                  label: "Activated At"
                },
                {
                  id: 'activationStatus',
                  label: "Activation Status"
                }
              ]} />
          </CardContent>
        </Card>
      </Stack>
    </activityTemplates.AdminActivityTemplate.FC>
  );
};
